export const ROLES = {
  VIEWER: 'Viewer',
  EDITOR: 'User',
  MANAGER: 'Manager',
  COMPANY_ADMIN: 'Company Admin',
  GLOBAL_ADMIN: 'Global Admin',
};

const RANK = {
  [ROLES.VIEWER]: 1,
  [ROLES.EDITOR]: 2,
  [ROLES.MANAGER]: 3,
  [ROLES.COMPANY_ADMIN]: 4,
  [ROLES.GLOBAL_ADMIN]: 100,
};

const LABELS = { [ROLES.EDITOR]: 'Editor' };

const COMPANY_ROLES = [ROLES.VIEWER, ROLES.EDITOR, ROLES.MANAGER, ROLES.COMPANY_ADMIN];

export const rankOf = (role) => RANK[role] || 0;

export const roleLabel = (role) => LABELS[role] || role;

export function selectCurrentRole(state) {
  const common = state.common;
  if (common.demoEnabled || common.demoMode) return ROLES.VIEWER;
  if (common.isAdmin) return ROLES.GLOBAL_ADMIN;
  if (!common.company || !common.companyRoles) return null;
  return common.companyRoles[String(common.company.id)] || null;
}

export const hasRole = (state, minRole) => rankOf(selectCurrentRole(state)) >= rankOf(minRole);

export function assignableRoles(actorRole) {
  if (rankOf(actorRole) < rankOf(ROLES.MANAGER)) return [];
  return COMPANY_ROLES.filter((role) =>
    role === ROLES.COMPANY_ADMIN ? actorRole === ROLES.GLOBAL_ADMIN : rankOf(role) <= rankOf(actorRole)
  );
}

/**
 * @param {string} actorRole
 * @param {{role: string, is_self: boolean, is_owner?: boolean}} row - a `/companies/<id>/users` item
 * @returns {boolean}
 */
export function canManageUser(actorRole, row) {
  if (row.is_self) return false;
  // Only a global admin may change or remove the company's billing owner.
  if (row.is_owner) return actorRole === ROLES.GLOBAL_ADMIN;
  if (actorRole === ROLES.GLOBAL_ADMIN) return true;
  if (rankOf(actorRole) < rankOf(ROLES.MANAGER)) return false;
  return rankOf(row.role) < rankOf(ROLES.COMPANY_ADMIN) && rankOf(row.role) <= rankOf(actorRole);
}

/**
 * Explains why a user-management row is read-only for this actor.
 * @param {string} actorRole
 * @param {{role: string, is_self: boolean, is_owner?: boolean}} row
 * @returns {string|null} tooltip text, or null when there is nothing to explain
 */
export function rowNote(actorRole, row) {
  if (row.is_self) return "You can't change your own role.";
  if (row.is_owner && actorRole !== ROLES.GLOBAL_ADMIN) return 'Only a Sakura admin can change the billing owner.';
  return null;
}
